// extracted by mini-css-extract-plugin
export var chevron = "_cw-4";
export var chevronExpanded = "_cw-5";
export var row = "_cw-0";
export var rowBody = "_cw-6";
export var rowDescription = "_cw-7";
export var rowHeader = "_cw-1";
export var rowTitle = "_cw-2";
export var rowTitleComplete = "_cw-3";